import { FormattedCities, ReturnedCities } from './types';

const formatCitiesOptions = (cities: ReturnedCities): FormattedCities =>
  cities.map((city) => ({
    id: city.name,
    value: city.name,
  }));

export default formatCitiesOptions;
